/* eslint-disable eslint-comments/no-restricted-disable, @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import mainIssueAggQueryParameters from '@jira/issue__main-issue-agg-query/src/__generated__/mainIssueAggQuery$parameters.ts';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { getMainIssueViewAggQueryVariables } from '@jira/issue__main-issue-agg-query/src/getMainIssueViewAggQueryVariables.tsx';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';

import type {
	IssueAppEntryPointEntrypointProps,
	IssueAppEntryPointQueries,
} from './IssueAppEntryPoint.entrypoint.types.tsx';

const EMPTY_OBJECT = {} as const;
const extractProjectKey = (issueKey: string): string => issueKey.split('-')[0];
type IssueAppEntryPointParams =
	| {
			cloudId: string;
			issueKey: string;
			querySource: 'entrypoint';
	  }
	| {
			context: object;
			tenantContext: object;
	  };
type IssueAppEntryPointComponent = EntryPointComponent<
	IssueAppEntryPointQueries,
	{},
	IssueAppEntryPointEntrypointProps,
	{}
>;

export const issueAppEntryPoint: EntryPoint<IssueAppEntryPointComponent, IssueAppEntryPointParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<IssueAppEntryPointComponent>(
			/* webpackChunkName: "async-issue-app-entrypoint" */ './IssueAppEntrypoint.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: (params) => {
			if (
				'querySource' in params &&
				params.querySource === 'entrypoint' &&
				expVal('wiv-issue-selector-perf-sprt', 'isEnabled', false)
			) {
				return {
					queries: {
						mainIssueAggQuery: {
							options: {
								fetchPolicy: 'store-or-network' as const,
							},
							parameters: mainIssueAggQueryParameters,
							variables: {
								cloudId: params.cloudId,
								issueKey: params.issueKey,
								projectKey: extractProjectKey(params.issueKey),
								...getMainIssueViewAggQueryVariables(params.issueKey),
							},
						},
					},
				};
			}

			return fg('nike-react-compiler-nin-transition-fixes') ? EMPTY_OBJECT : {};
		},
	});
